import React from 'react';
import { PencilSquareIcon } from '@heroicons/react/24/solid';

const ClientCard = ({ clients, handleEdit, handleToggleStatus }) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="grid gap-4 md:hidden">
        {clients.length === 0 ? (
                <div className="text-center text-gray-500 py-10">
                    No clients found. Add one to get started.
                </div>
            ) : (
            <>
                {clients.map((client, idx) => (
                    <div key={idx} className="border rounded shadow p-4 bg-white">
                    <div className="flex justify-between items-start">
                        <div>
                        <p className="font-semibold">{u(client.client_code)}</p>
                        <p className="font-semibold">{u(client.name)}</p>
                        <p className="text-sm text-gray-600">{client.phone}</p>
                        <p className="text-sm text-gray-600">{u(client.email)}</p>
                        <p
                          className={`text-sm font-medium mt-1 cursor-pointer ${
                            client?.is_active ? 'text-green-600' : 'text-red-500'
                          }`}
                          onClick={() => handleToggleStatus(client)}
                        >
                          {client?.is_active ? 'ACTIVE' : 'INACTIVE'}
                        </p>
                        <div className="mt-1 text-sm text-gray-600">
                          <div>{u(client.short_code)}</div>
                            <div>{u(client.address_line1)}</div>
                            <div>{u(client.address_line2)}</div>
                            <div>{u(client.city)}</div>
                            <div>{u(client.state)}</div>
                            <div>{client.pincode}</div>
                        </div>
                        </div>
                        <button
                        onClick={() => handleEdit(client)}
                        >
                        <PencilSquareIcon className="h-5 w-5 text-blue-600 hover:text-blue-800" />
                        </button>
                    </div>
                    </div>
                ))}
            </>
        )}
    </div>
  );
};

export default ClientCard;
